import { HotmartRum } from "@commons/observability"
import { ModeEnum } from "../types/mode.enum"
import { CustomTheme } from "../types/customTheme.interface"
import { ThemeConfig } from "../types/themeConfig.interface"
import { ClubSlugHandler } from "./clubSlug.handler"
import { RouterHandlerInterface } from "./types/routeHandler.interface"
import { TrackingEvent } from "../trackingEvent"
import { EventInterface } from "../types/event.interface"
import { abortController } from "../util/request"

const url = {
    production: 'https://api-content-platform-space-gateway.cp.hotmart.com',
    staging: 'https://api-content-platform-space-gateway.buildstaging.com',
    local: 'https://api-content-platform-space-gateway.buildstaging.com'
}

export class ClubTheme implements CustomTheme {
    defaultMode = ModeEnum.DARK

    private baseUrl = url[global.ENV]
    private slugHandler: RouterHandlerInterface
    private route: string | undefined
    private readonly timeout = 2500
    private trackingEvent: TrackingEvent

    constructor(trackingEvent: TrackingEvent) {
        this.slugHandler = new ClubSlugHandler()
        this.route = this.slugHandler.getRoute() 
        this.trackingEvent = trackingEvent
    }

    get brand(): string | undefined {
        return this.slugHandler.getBrandSlug()
    }

    private get apiFullUrl(): string {
        return `${this.baseUrl}/${this.route}`
    } 

    async getTheme(): Promise<ThemeConfig> {
        if (!this.brand) return {} as ThemeConfig

        try {
            const { controller, timer } = abortController(this.timeout)
            const response = await fetch(this.apiFullUrl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                signal: controller?.signal
            })

            clearTimeout(timer)

            const data = await response.json()

            if(response.status != 200) throw data

            const backgroundImage = data?.settings?.backgroundImage

            return {
                name: data?.name,
                mode: data?.settings?.theme.toLowerCase(),
                backgroundImage: backgroundImage ? {
                    desktop: backgroundImage?.imageUrlBackground,
                    tablet: backgroundImage?.imageUrlBackground2,
                    mobile: backgroundImage?.imageUrlBackground1,
                    altText: backgroundImage?.altText
                } : undefined,
                logos: data?.settings?.logos
            }
        } catch (error: any) {
            const event: EventInterface = {
                brand: this.brand,
                error: {
                    code: String(error?.code),
                    message: error?.message || '',
                    status: error?.status || 500,
                    path: this.apiFullUrl
                }
            }

            this.trackingEvent.send(event)
            HotmartRum.captureException(
                new Error(`[API Club error] - ${error?.code}: ${error?.message}`)
            )

            return {} as ThemeConfig
        } 
    }
}